export enum TrackEvent {
  CREATED = 'TRACK_CREATED',
}

export enum TrackingEvent {
  PageViewed = 'Page Viewed',
  ViewedItem = 'Viewed Item',
  AddedItem = 'Added Item',
  RemovedItem = 'Removed Item',
  StartedCheckoutItem = 'Started Checkout Item',
  StartedCheckout = 'Started Checkout',
  ReturnedToCartFromCheckout = 'Returned To Cart From Checkout',
  AbandonedCheckout = 'Abandoned Checkout',
  RecoveredCheckout = 'Recovered Checkout',
  PurchasedItem = 'Purchased Item',
  CompletedOrder = 'Completed Order',
  ViewedReservationRequest = 'Viewed Reservation Request',
  ReservationRequested = 'Reservation Requested',
  ViewedGuestistRequest = 'Viewed Guestist Request',
  GuestlistRequested = 'Guestlist Requested',
}

export const TablelistTrackChannelName = 'tl.channel.track'
